import {
  CHORD_PAIRS,
  VOICE_LEADING_IDIOMS,
  VOICE_LEADING_KEY_POOL,
} from '@tunasong/music-lib'
import type { ChordPair, VoiceLeadingIdiom, VoiceLeadingKey } from '@tunasong/music-lib'

export type VoiceLeadingSubMode = 'explore' | 'quiz'

/** Parse `?mode=…` into a sub-mode, or null when invalid/absent. */
export const parseVoiceLeadingSubMode = (raw: string | null): VoiceLeadingSubMode | null =>
  raw === 'explore' || raw === 'quiz' ? raw : null

/** Parse `?pair=…` into a ChordPair, or null when invalid/absent. */
export const parseChordPair = (raw: string | null): ChordPair | null =>
  (CHORD_PAIRS as readonly string[]).includes(raw ?? '') ? (raw as ChordPair) : null

/** Parse `?key=…` into a VoiceLeadingKey, or null when not in the pool. */
export const parseVoiceLeadingKey = (raw: string | null): VoiceLeadingKey | null =>
  (VOICE_LEADING_KEY_POOL as readonly string[]).includes(raw ?? '') ? (raw as VoiceLeadingKey) : null

/** Parse `?idiom=…` into a VoiceLeadingIdiom, defaulting to classical. */
export const parseVoiceLeadingIdiom = (raw: string | null): VoiceLeadingIdiom =>
  (VOICE_LEADING_IDIOMS as readonly string[]).includes(raw ?? '')
    ? (raw as VoiceLeadingIdiom)
    : 'classical'
